import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.scss";
import { useLoginUserMutation } from "../../redux-toolkit/services/authService";
import { toast } from "react-toastify";
import { alertMessage } from "../../utils/AlertService";
import { setAuthState } from "../../redux-toolkit/slices/authSlice";
import { useDispatch } from "react-redux";
import Loading from "../../components/Loading";
import ForgotResetPassword from "./ForgotResetPassword";
import { PAGE_TITLE } from "../../constant/reportType";
import { Typography } from "antd";
import Header from "../../components/Header/Header";

type Props = {};

const { Link: AntdLink } = Typography;

const Login = (props: Props) => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotPasswordShow, setForgotPasswordShow] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Mutation
  const [loginUser, loginResponse] = useLoginUserMutation();

  const handleForgotPasswordShow = () => setForgotPasswordShow(true);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log(e)
    if (!email || !password) {
      toast.error("Please enter your login credentials");
    } else {
      await loginUser({
        username: email,
        password: password,
        // userRole: "admin",//values.userrole,
      });
    }
  };

  useEffect(() => {
    if (loginResponse.isSuccess) {
      alertMessage("Login successful", "success");
      dispatch(setAuthState(loginResponse.data));

      const localUserObj = {
        token: loginResponse.data.jwtToken,
        userType: loginResponse.data.userRoleName,
        id: loginResponse.data.id,
        username: loginResponse.data.username,
        packageId:loginResponse.data.packageId,
        defaultCurrency:loginResponse.data.defaultCurrency,
        createdDate:loginResponse.data.createdDate,
        packageType:loginResponse.data.packageType,
      };
      console.log(localUserObj ,"localUserObj");

      localStorage.setItem("localUser", JSON.stringify(localUserObj));
      localStorage.setItem("name", JSON.stringify(loginResponse.data.username));

      // Navigate to a different page after login
      navigate("/home");

    } else if (loginResponse.isError) {
      let response: any = loginResponse?.error;
      alertMessage(response.error.data.serviceErrors[0].msg ?
        response?.error?.data?.serviceErrors[0].msg : "Invalid email or password", "error");
    }
  }, [loginResponse.isSuccess]);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="container" style={{ paddingRight: "5rem", paddingLeft: "5rem" }}>
          <div className="row cdvfdfd">
            <div className="col-lg-5 col-md-12 login-box">
              <div className="row justify-content-center">
                <div className="col-lg-12 col-md-6 log-det">
                  <h2 className="text-2xl fw-bold mb-4 text-center">Login</h2>
                  <form onSubmit={handleSubmit}>
                    {loginResponse.isSuccess ?
                      <Loading /> : ("")}
                    <div className="text-box-cont">
                      <input
                        type="text"
                        className="form-control mb-1"
                        placeholder="Username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                      <input
                        type="password"
                        className="form-control mt-4"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} />

                      <div>
                        <button
                          className="btn btn-dark text-white fw-bold mt-3"
                          type="submit"
                        >
                          LOG IN
                        </button>
                      </div>
                      <div className="row">
                        <p className="forget-p">
                          Don't have an account?{" "}
                          <Link className="text-primary fw-bold" to="/signup">
                            Sign Up Now
                          </Link>
                        </p>
                        <p className="text-center mx-1">
                          <AntdLink onClick={handleForgotPasswordShow} className="text-primary fw-bold">
                            Forgot password?
                          </AntdLink>
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {forgotPasswordShow && (
          <ForgotResetPassword
            forgotResetShow={forgotPasswordShow}
            setForgotResetShow={setForgotPasswordShow}
            title={PAGE_TITLE.FORGOT_PASSWORD} />
        )}
      </div>
    </>
  );
}

export default Login;
